require("./page.scss");